import $api from "@http";

export default class UsersService {
  static async getWeeklyActivity({id}) {
    return $api.get(`/api/v1/users/${id}/weekly_activity`);
  }

  static async getReps() {
    return $api.get(`/api/v1/reps`);
  }

  static async getManagers() {
    return $api.get(`/api/v1/managers`);
  }

  static async getUsers({page, size, search, sort, with_archived}) {
    const params = new URLSearchParams();
    params.append("page", page);
    params.append("page_size", size);
    params.append("with_archived", with_archived);

    if (search) {
      const userTypes = ["admin", "manager", "representative"];

      const dateRegex = /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-(\d{4})$/;

      if (dateRegex.test(search.trim())) {
        params.append("q[created_at_gteq]", search.trim());
      } else if (userTypes.includes(search)) {
        params.append("type_search", search);
      } else {
        params.append(
          "q[name_or_email_or_lastname_or_product_line_name_or_country_name_cont]",
          search,
        );
      }
    }

    if (sort?.value === "role") {
      params.append("q[s][]", `type ${sort.direction || "asc"}`);
    } else if (sort?.value === "name") {
      params.append("q[s][]", `lastname ${sort.direction || "asc"}`);
      params.append("q[s][]", `name ${sort.direction || "asc"}`);
    } else if (sort?.value === "product_line") {
      params.append("q[s][]", `product_line_name ${sort.direction || "asc"}`);
    } else if (sort?.value) {
      params.append("q[s][]", `${sort.value} ${sort.direction || "asc"}`);
    }

    return $api.get(`/api/v1/users?${params.toString()}`);
  }

  static async getAllUsers() {
    return $api.get(`/api/v1/users`);
  }

  static async viewUser({id}) {
    return $api.get(`/api/v1/users/${id}`);
  }

  static async createUser({user}) {
    const hasFiles =
      user.user.cover &&
      (user.user.cover instanceof File ||
        (user.user.cover.file && user.user.cover.file instanceof File) ||
        (user.user.cover.path && user.user.cover.path !== ""));

    if (hasFiles) {
      const formData = new FormData();

      Object.keys(user.user).forEach((key) => {
        if (user.user[key] !== null && user.user[key] !== undefined) {
          if (key === "cover" && user.user.cover) {
            if (user.user.cover instanceof File) {
              formData.append("user[cover]", user.user.cover);
            } else if (
              user.user.cover.file &&
              user.user.cover.file instanceof File
            ) {
              formData.append("user[cover]", user.user.cover.file);
            } else if (user.user.cover.path) {
              formData.append("user[cover]", JSON.stringify(user.user.cover));
            }
          } else {
            formData.append(`user[${key}]`, user.user[key]);
          }
        }
      });

      return $api.post(`/api/v1/users`, formData);
    } else {
      return $api.post(`/api/v1/users`, user);
    }
  }

  static async updateUser({id, user}) {
    const hasFiles =
      user.user.cover &&
      (user.user.cover instanceof File ||
        (user.user.cover.file && user.user.cover.file instanceof File) ||
        (user.user.cover.path && user.user.cover.path !== ""));

    if (hasFiles) {
      const formData = new FormData();

      Object.keys(user.user).forEach((key) => {
        if (user.user[key] !== null && user.user[key] !== undefined) {
          if (key === "cover" && user.user.cover) {
            if (user.user.cover instanceof File) {
              formData.append("user[cover]", user.user.cover);
            } else if (
              user.user.cover.file &&
              user.user.cover.file instanceof File
            ) {
              formData.append("user[cover]", user.user.cover.file);
            } else if (user.user.cover.path) {
              formData.append("user[cover]", JSON.stringify(user.user.cover));
            }
          } else {
            formData.append(`user[${key}]`, user.user[key]);
          }
        }
      });

      return $api.patch(`/api/v1/users/${id}`, formData);
    } else {
      return $api.patch(`/api/v1/users/${id}`, user);
    }
  }

  static async archiveUser({id}) {
    return $api.post(`/api/v1/users/${id}/archive`);
  }

  static async unArchiveUser({id}) {
    return $api.post(`/api/v1/users/${id}/restore`);
  }

  static async deleteUser({id}) {
    return $api.delete(`/api/v1/users/${id}`);
  }
}
